(function () {
    angular.module('tmx-app').factory('CurrencyService', ['tmxResource','$mdMedia', function (tmxResource,$mdMedia) {
        var currency = tmxResource("Currency");

        currency.columns = [
            // {
            //     field: "CurrencyID",
            //     title: "CurrencyID",
            //     type: "integer",
            //     search: true,
            //     hidden:true,
            //     headerTemplate: "<span  ng-class=\"{ 'filter-active' : CurrencyCtrl.isFiltered('CurrencyID')}\" >{{'CurrencyID' | translate}} <i class='fa fa-filter' ng-if='CurrencyCtrl.isFiltered(\"CurrencyID\")' ></i></span>",
            //     template: "<md-button class='tmx-primary-text' ng-click='CurrencyCtrl.clickEdit(dataItem)' ng-disabled='dataItem.Status != \"Active\"' ng-bind='dataItem.CurrencyID'></md-button><div class='subtitle'> <span ng-bind='dataItem.CurrencyDescription'</span></div>"
            // },
            {
                field: "CurrencyCode",
                title: "CurrencyCode",
                type: "text",
                search: true,
                width: $mdMedia('gt-sm')?'50%':'150px',
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : CurrencyCtrl.isFiltered('CurrencyCode')}\" >{{'CurrencyCode' | translate}} <i class='fa fa-filter' ng-if='CurrencyCtrl.isFiltered(\"CurrencyCode\")' ></i></span>",
                template: "<md-button class='tmx-primary-text-grid' ng-click='CurrencyCtrl.clickEdit(dataItem)' ng-disabled='(dataItem.Status != \"Active\" && !CurrencyCtrl.editPermission)' ng-bind='dataItem.CurrencyCode'></md-button><div class='margin-bottom-2'><span class='chip' ng-style={{dataItem.StatusBKColor}} ng-bind='dataItem.Status'></span> <span class='subtitle' ng-bind='dataItem.CurrencyDescription'></span> </div>"                
            },
            {
                field: "CurrencySymbol",
                title: "CurrencySymbol",
                type: "text",
                search: true,
                width: $mdMedia('gt-sm')?'15%':'150px',                
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : CurrencyCtrl.isFiltered('CurrencySymbol')}\" >{{'CurrencySymbol' | translate}} <i class='fa fa-filter' ng-if='CurrencyCtrl.isFiltered(\"CurrencySymbol\")' ></i></span>",
                template: "<span ng-bind='dataItem.CurrencySymbol'></span>"
            },
            {
                field: "BaseFactor",
                title: "BaseFactor",
                type: "amount",
                search: true,
                width: $mdMedia('gt-sm')?'50%':'150px',
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : CurrencyCtrl.isFiltered('BaseFactor')}\" >{{'BaseFactor' | translate}} <i class='fa fa-filter' ng-if='CurrencyCtrl.isFiltered(\"BaseFactor\")' ></i></span>",
                template: "<span ng-bind='dataItem.BaseFactor'></span>"
            },      
            {
                field: "CurrencyDescription",
                title: "CurrencyDescription",
                type: "text",
                search: true,
                width: $mdMedia('gt-sm')?'15%':'150px',
                hidden:true,
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : CurrencyCtrl.isFiltered('CurrencyDescription')}\" >{{'CurrencyDescription' | translate}} <i class='fa fa-filter' ng-if='CurrencyCtrl.isFiltered(\"CurrencyDescription\")' ></i></span>",
                template: "<span ng-bind='dataItem.CurrencyDescription'></span>"
            },
            {
                field: "Status",
                title: "Status",
                type: "text",
                search: true,
                width: $mdMedia('gt-sm')?'15%':'150px',
                hidden:true,
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : CurrencyCtrl.isFiltered('Status')}\" >{{'Status' | translate}} <i class='fa fa-filter' ng-if='CurrencyCtrl.isFiltered(\"Status\")' ></i></span>",
                template: "<span ng-bind='dataItem.Status'></span>"
            },
        ]

        return currency;
    }]);
})();